import { GlobalMakerService } from "~/core/services/GlobalMakerService"
export default ({ $auth }, inject) => {
    GlobalMakerService.setAuth($auth);
};